<template>
  <el-card>
    <el-tabs v-model="projectUserType" @tab-click="fetchAll">
      <el-tab-pane
        name="client_id"
        label="用戶清單"
        :lazy="true"
      />
      <!--el-tab-pane
        name="warning_target"
        label="注意值告警對象"
        :lazy="true"
      />
      <el-tab-pane
        name="alert_target"
        label="警戒值告警對象"
        :lazy="true"
      />
      <el-tab-pane
        name="action_target"
        label="行動值告警對象"
        :lazy="true"
      />
      <el-tab-pane
        name="down_target"
        label="故障告警對象"
        :lazy="true"
      /-->
    </el-tabs>
    <div style="display:flex; gap:12px; align-items:center; margin-bottom:12px; flex-wrap:wrap;">
      <el-input
        v-model="keyword"
        placeholder="搜尋：姓名 / Email / 單位 / 專案名稱"
        clearable
        style="width:420px;"
      />
      <el-button type="primary" :loading="loading" @click="loadRelations">重新整理</el-button>
      <el-switch
        v-model="showProjects"
        active-text="展開 Projects"
        inactive-text=""
      />
      <el-switch
        v-model="showGroups"
        active-text="展開 Groups"
        inactive-text=""
        @change="onToggleGroups"
      />
      <el-switch
        v-model="showDisabled"
        active-text="顯示已停用用戶"
        inactive-text=""
      />
      <div v-if="!loading" style="color:#909399;">
        共 {{ filteredRows.length }} 筆
      </div>
    </div>

    <el-table
      v-if="filteredRows.length > 0"
      :data="filteredRows"
      border
      style="width: 100%"
      size="mini"
      :row-key="rowKey"
    >
      <el-table-column prop="company" label="單位" min-width="200" sortable />
      <el-table-column prop="name" label="姓名" min-width="160" sortable />
      <el-table-column prop="roles" label="權限" min-width="120" sortable />
      <el-table-column prop="email" label="Email" min-width="220" sortable />
      <el-table-column label="LINE" min-width="85" sortable :sort-method="(a, b) => (a.isLineUse ? 1 : 0) - (b.isLineUse ? 1 : 0)">
        <template #default="{ row }">
          <div v-if="row.isLineUse">
            <font-awesome-icon icon="check" />
            TRUE
          </div>
          <div v-else>
            <font-awesome-icon icon="times" />
            FALSE
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="Phone" sortable />
      <el-table-column label="Projects" min-width="300">
        <template #default="{ row }">
          <template v-if="showProjects">
            <div v-if="row.projects && row.projects.length">
              <el-tag
                v-for="p in row.projects"
                :key="p._id || p.project_id"
                size="mini"
                style="margin: 2px 6px 2px 0;"
              >
                {{ p.project_id }}
              </el-tag>
            </div>
            <span v-else style="color:#C0C4CC;">-</span>
          </template>
          <span v-else style="color:#C0C4CC;">—</span>
        </template>
      </el-table-column>

      <el-table-column label="所屬告警群組" min-width="270">
        <template slot-scope="scope">
          <template v-if="showGroups">
            <div v-if="scope.row.groups && scope.row.groups.length">
              <el-tag
                v-for="group in scope.row.groups"
                :key="group._id"
                size="small"
                class="mr-8 mb-4"
                type="info"
              >
                {{ group.notes || group._id }}
              </el-tag>
            </div>
            <span v-else style="color: #C0C4CC;">未加入任何群組</span>
          </template>
          <span v-else style="color:#C0C4CC;">—</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" min-width="110">
        <template #default="{ row }">
          <el-button
            size="mini"
            type="warning"
            plain
            :loading="unlockingId === row._id"
            @click="unlockUser(row)"
          >
            解除鎖定
          </el-button>
        </template>
      </el-table-column>

    </el-table>

    <div v-else-if="!loading" style="color:#909399; padding: 12px 0;">
      無資料
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'UserProjectRelation',
  data() {
    return {
      loading: false,
      keyword: '',
      rows: [], // [{ _id, email, name, company, roles, projects: [...] }]
      projectUserType: 'client_id',
      showProjects: false,
      showGroups: false,
      showDisabled: false,
      alertGroups: [],
      alertGroupsLoaded: false,
      unlockingId: null,
    };
  },
  computed: {
    enrichedRows() {
      const rows = this.showDisabled ? this.rows : this.rows.filter(user => user.roles !== 'disabled');
      if (!this.alertGroupsLoaded) return rows;
      return rows.map(user => ({
        ...user,
        groups: this.alertGroups.filter(g =>
          Array.isArray(g.userList) &&
          g.userList.some(u => u._id === user._id || u === user._id),
        ),
      }));
    },
    filteredRows() {
      const k = (this.keyword || '').trim().toLowerCase();
      if (!k) return this.enrichedRows;

      return this.enrichedRows.filter(r => {
        let s = `${r.email || ''} ${r.name || ''} ${r.company || ''} ${r.roles || ''}`.toLowerCase();
        if (this.showProjects) {
          s += ' ' + (r.projects || []).map(p => p.project_id || '').join(' ').toLowerCase();
        }
        if (this.showGroups) {
          s += ' ' + (r.groups || []).map(g => g.notes || g._id || '').join(' ').toLowerCase();
        }
        return s.includes(k);
      });
    },
  },
  mounted() {
    this.fetchAll();
  },
  methods: {
    rowKey(row) {
      return row._id || row.email;
    },

    // 簡單的併發限制（避免一次對 N 個 user 全部打 API）
    async mapLimit(list, limit, mapper) {
      const ret = new Array(list.length);
      let i = 0;

      const workers = new Array(Math.min(limit, list.length)).fill(0).map(async () => {
        while (i < list.length) {
          const idx = i++;
          ret[idx] = await mapper(list[idx], idx);
        }
      });

      await Promise.all(workers);
      return ret;
    },

    async loadRelations() {
      this.loading = true;
      try {
        // 1) 先抓所有用戶
        const usersRes = await this.$axios({
          category: 'admin',
          method: 'get',
          apiName: 'client',
        });

        const users = Array.isArray(usersRes?.data) ? usersRes.data : [];

        // 2) 逐個 user 抓其 project list（沿用你原本 edit 頁面呼叫的 API）
        const rows = await this.mapLimit(users, 6, async (u) => {
          let projects = [];
          try {
            const pRes = await this.$axios({
              category: 'user',
              method: 'get',
              apiName: `${u._id}/getUserUsedProjectList`,
            });
            projects = Array.isArray(pRes?.data) ? pRes.data : [];
          } catch (e) {
            // 單一 user 失敗不應該讓整頁掛掉
            projects = [];
            console.warn(`[relation] load projects failed: user=${u?._id}`, e);
          }

          return {
            _id: u._id,
            email: u.email,
            name: u.name,
            company: u.company,
            roles: u.roles,
            isLineUse: u.isLineUse,
            phone: u.phone,
            projects,
          };
        });

        this.rows = rows;
      } catch (e) {
        console.error(e);
        this.$message.error('載入用戶/專案關聯失敗');
        this.rows = [];
      } finally {
        this.loading = false;
      }
    },

    unlockUser(row) {
      const email = row.email || row._id;
      this.$confirm(`確定要解除 ${email} 的登入鎖定嗎？`, '確認解除鎖定', {
        confirmButtonText: '解除鎖定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.unlockingId = row._id;
        return this.$axios({
          category: 'admin',
          method: 'put',
          apiName: `client/${row._id}/unlock`,
        });
      }).then(res => {
        this.$notifySuccess((res.data && res.data.message) || '已解除登入鎖定');
      }).catch(err => {
        if (err !== 'cancel') this.$notifyError(err);
      }).finally(() => {
        this.unlockingId = null;
      });
    },
    async onToggleGroups(val) {
      if (val && !this.alertGroupsLoaded) {
        await this.loadAlertGroups();
      }
    },
    async loadAlertGroups() {
      try {
        const res = await this.$axios({
          category: 'alerts',
          method: 'get',
          apiName: 'getAllAlertGroup',
        });
        this.alertGroups = Array.isArray(res.data) ? res.data : [];
        this.alertGroupsLoaded = true;
      } catch (e) {
        console.error(e);
        this.$message.error('載入告警群組失敗');
        this.showGroups = false;
      }
    },
    async fetchAll() {
      console.log(this.projectUserType);
      this.loading = true;
      try {
        const res = await this.$axios({
          category: 'user',
          method: 'get',
          apiName: 'getAllUserUsedProjectList',
          params: {
            type: this.projectUserType,
          },
        });

        // 期待後端回傳：[{ user_id,email,name,company,projects:[] }, ...]
        this.rows = Array.isArray(res.data) ? res.data : [];
        console.log(this.rows);
      } catch (e) {
        console.error(e);
        this.$message.error('載入失敗');
        this.rows = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
